module.exports = __webpack_public_path__ + "static/media/libro.91cdd511.jpg";